import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { NmChipNav } from '../components/nm/NmChip';

export function AppShell() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-nm-bg text-nm-ink">
      <header className="sticky top-0 z-30 border-b border-nm-border bg-nm-surface">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Link to="/leads" className="group flex min-w-0 items-center gap-2.5">
            <span className="inline-block h-2 w-2 shrink-0 rounded-full bg-nm-accent" aria-hidden />
            <span className="truncate font-display text-lg font-semibold tracking-tight text-nm-ink group-hover:text-nm-accent">
              Flashpoint
            </span>
          </Link>

          <nav className="hidden items-center gap-1.5 sm:flex">
            <NmChipNav to="/leads" label="Previews" />
            <NmChipNav to="/template-qa" label="QA" />
          </nav>

          {user && (
            <div className="flex shrink-0 items-center gap-2">
              <span
                className="hidden max-w-[10rem] truncate rounded-full border border-nm-border bg-nm-accent-tint px-2.5 py-1 font-mono text-xs text-nm-muted sm:inline"
                title={user.email ?? ''}
              >
                {user.email?.split('@')[0] ?? '—'}
              </span>
              <button type="button" onClick={() => void signOut()} className="fp-btn fp-btn-ghost !py-1.5 !px-3">
                Sign out
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-8 pb-28 sm:px-6 sm:pb-12">
        <Outlet />
      </main>

      <nav className="fixed inset-x-0 bottom-0 z-20 border-t border-nm-border bg-nm-surface sm:hidden">
        <div className="mx-auto flex max-w-7xl items-stretch gap-1 px-1 py-1">
          <NmChipNav to="/leads" label="Previews" className="flex flex-1 justify-center" />
          <NmChipNav to="/template-qa" label="QA" className="flex flex-1 justify-center" />
        </div>
      </nav>
    </div>
  );
}
